var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("card-title-component", { attrs: { title: _vm.localName } }),
      _vm._v(" "),
      _c("div", { staticClass: "card-content" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "name-form-group",
                    label: _vm.$t("pets.pet.name"),
                    "label-for": "name-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      id: "name-input",
                      type: "text",
                      required: "",
                      placeholder: _vm.$t("pets.pet.name")
                    },
                    model: {
                      value: _vm.localName,
                      callback: function($$v) {
                        _vm.localName = $$v
                      },
                      expression: "localName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "species-form-group",
                    label: _vm.$t("pets.pet.species"),
                    "label-for": "species-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      id: "species-input",
                      type: "text",
                      required: "",
                      placeholder: _vm.$t("pets.pet.species")
                    },
                    model: {
                      value: _vm.localSpecies,
                      callback: function($$v) {
                        _vm.localSpecies = $$v
                      },
                      expression: "localSpecies"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "birthdate-form-group",
                    label: _vm.$t("pets.pet.birthdate"),
                    "label-for": "birthdate-input"
                  }
                },
                [
                  _c("datepicker", {
                    staticClass: "o-form",
                    attrs: {
                      id: "birthdate-input",
                      format: "dd.MM.yyyy",
                      language: this.getLanguage()
                    },
                    model: {
                      value: _vm.localBirthdate,
                      callback: function($$v) {
                        _vm.localBirthdate = $$v
                      },
                      expression: "localBirthdate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "transponder-id-form-group",
                    label: _vm.$t("pets.pet.transponderId"),
                    "label-for": "transponder-id-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      id: "transponder-id-input",
                      type: "text",
                      required: "",
                      placeholder: _vm.$t("pets.pet.transponderId")
                    },
                    model: {
                      value: _vm.localTransponderId,
                      callback: function($$v) {
                        _vm.localTransponderId = $$v
                      },
                      expression: "localTransponderId"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "veterinarian-form-group",
                    label: _vm.$t("pets.pet.veterinarian"),
                    "label-for": "veterinarian-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      id: "veterinarian-input",
                      type: "text",
                      required: "",
                      placeholder: _vm.$t("pets.pet.addressPlaceholder")
                    },
                    model: {
                      value: _vm.localVeterinarian,
                      callback: function($$v) {
                        _vm.localVeterinarian = $$v
                      },
                      expression: "localVeterinarian"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "custody-after-death-form-group",
                    label: _vm.$t("pets.pet.custody"),
                    "label-for": "custody-after-death-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      id: "custody-after-death-input",
                      type: "text",
                      required: "",
                      placeholder: _vm.$t("pets.pet.addressPlaceholder")
                    },
                    model: {
                      value: _vm.localCustodyAfterDeath,
                      callback: function($$v) {
                        _vm.localCustodyAfterDeath = $$v
                      },
                      expression: "localCustodyAfterDeath"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "notes-form-group",
                    label: _vm.$t("pets.pet.notes"),
                    "label-for": "notes-input"
                  }
                },
                [
                  _c("b-form-textarea", {
                    staticClass: "o-form",
                    attrs: {
                      id: "notes-input",
                      type: "text",
                      rows: 5,
                      "max-rows": 10,
                      placeholder: _vm.$t("pets.pet.notes")
                    },
                    model: {
                      value: _vm.localNotes,
                      callback: function($$v) {
                        _vm.localNotes = $$v
                      },
                      expression: "localNotes"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col button-div" },
            [
              _c(
                "b-button",
                {
                  staticClass: "delete-button o-button",
                  on: {
                    click: function($event) {
                      _vm.deletePet(_vm.petId)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("pets.deleteButton")) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "save-button o-button",
                  on: { click: _vm.savePet }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("pets.saveButton")) +
                      "\n                "
                  )
                ]
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bbe8159", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bbe8159","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pets/PetComponent.vue
// module id = null
// module chunks = 